/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/components/ClientListContent.tsx
*/

import React from 'react';
import {
  ContentWrapper,
  Description,
  ClientListCopyContent,
  HomePageTitle,
  ClientListImageWrapper,
  Filler,
  ALinkButtonWrapper,
  ClientListImage,
  ClientListMobileImageWrapper,
  ClientListImageMobile,
  ClientListHireMeMobileLinkButtonWrapper,
} from './HomePage.css';
import Link from 'next/link';

export default function ClientListContent({}: IAnimatedHeaderContentProps) {
  return (
    <>
      <ContentWrapper>
        <ClientListCopyContent>
          <HomePageTitle paddingTop="80%">Self-Starter</HomePageTitle>
          <Description top="5em">
            Eli Elad Elrom is a technical coach. As a writer, he authored and co-authored several
            technical books. Eli consulted for a variety of clients, from large corporations such as
            AT&T, HBO, Viacom, NBC Universal, and Weight Watchers, to smaller startups. Aside from
            coding, Eli is also a PADI diving instructor and a pilot.
          </Description>
          <ALinkButtonWrapper top="4em" width="10em">
            <Link href="/coaching">HIRE ME</Link>
          </ALinkButtonWrapper>
        </ClientListCopyContent>
      </ContentWrapper>
      <Filler />
      <Link href="/showcase">
        <ClientListImageWrapper>
          <ClientListImage />
        </ClientListImageWrapper>
      </Link>
      <Link href="/showcase">
        <ClientListMobileImageWrapper>
          <ClientListImageMobile />
        </ClientListMobileImageWrapper>
      </Link>
      <ClientListHireMeMobileLinkButtonWrapper>
        <Link href="/coaching">HIRE ME</Link>
      </ClientListHireMeMobileLinkButtonWrapper>
    </>
  );
}

interface IAnimatedHeaderContentProps {
  isLightsOn: boolean;
}
